$('.mazuripet-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1
            }
        }
    ]
});

$(document).ready(function(){
$('.product-page-left-block h2').on('click',function(){
  $('.product-sidebar-filters-block').show();
  $('.product-sidebar-filters-block').css('width','100%'); 
});
$('.product-filters-list .btn-close').on('click',function(){
  $('.product-sidebar-filters-block').hide();
  $('.product-sidebar-filters-block').css('width','0%'); 
  
});
  
});

  
$(document).ready(function() {

  //Bold Custom Pricing for retail price start -->
  $( "li.grid__item" ).each(function( index ) {

    var boldID = '#money-price-'+index;
    var bold_price = $(boldID).text();

    var retailID = '#retail-price-'+index;
    var retail_price = $(retailID).text();

    bold_price = bold_price.replace('$', '');
    retail_price = retail_price.replace('$', '');

    var bold_int = parseFloat(bold_price);
    var retail_int = parseFloat(retail_price);


    if( bold_int == retail_int ){
      $(retailID).hide();
    }

  });
  //Bold Custom Pricing for retail price end -->

  // for cart weight update start

  $('input.cart__qty-input').on('input', function() {
    var item_size = parseInt($('#size_value').val());
    var update_weight = item_size * $(this).val();
    $('#cart_weight').val(update_weight);
  });

  // for cart weight update start

});

/* bv review custom script */
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(()=>{
    let links = document.querySelector('[data-bv-show="reviews"]').shadowRoot.querySelectorAll("a");
    links.forEach(link => {
      link.href = window.bvDCC.catalogData.catalogProducts[0].productPageURL;
    });
  }, 4000)
});
